import { PortalPreviewData } from './portalTypes';

export const portalMockData: PortalPreviewData = {
  clientName: 'Ana Silva',
  clientEmail: 'ana.silva@empresaexemplo.com.br',
  companyName: 'Empresa Exemplo',
  projects: [
    {
      id: 'crm',
      name: 'Implementação CRM',
      statusLabel: 'Em andamento',
      summary: 'Implantação do CRM da Baruk com foco em processos comerciais, integração e capacitação.',
      started: true,
      active: true,
      ownerName: 'Mariana Silva',
    },
    {
      id: 'app-vendedor',
      name: 'App do vendedor',
      statusLabel: 'Em andamento',
      summary: 'Consulta de estoque e pedido pelo celular da equipe comercial.',
      started: true,
      active: true,
      ownerName: 'Ana Ribeiro',
    },
    {
      id: 'app-mobile',
      name: 'App Mobile',
      statusLabel: 'Concluído',
      summary: 'Aplicativo para consulta e pedidos, entregue e encerrado.',
      started: true,
      active: false,
      ownerName: 'Rafael Lima',
    },
  ],
  sprints: [
    { id: 's-out-1', projectId: 'crm', startDate: '2026-10-05', endDate: '2026-10-11' },
    { id: 's-out-2', projectId: 'crm', startDate: '2026-10-12', endDate: '2026-10-18' },
    { id: 's-out-3', projectId: 'crm', startDate: '2026-10-19', endDate: '2026-10-25' },
    { id: 's-app-1', projectId: 'app-vendedor', startDate: '2026-10-05', endDate: '2026-10-11' },
    { id: 's-app-2', projectId: 'app-vendedor', startDate: '2026-10-12', endDate: '2026-10-18' },
    { id: 's-app-3', projectId: 'app-vendedor', startDate: '2026-10-19', endDate: '2026-10-25' },
  ],
  roadmap: [
    {
      id: 'r-descoberta',
      projectId: 'crm',
      title: 'Descoberta',
      description: 'Escopo dos pedidos, filiais e regras de preço alinhados com a operação.',
      kind: 'milestone',
      status: 'achieved',
      plannedDate: '2026-09-18',
    },
    {
      id: 'r-integracao',
      projectId: 'crm',
      title: 'Integração com o ERP',
      description: 'Preço, estoque e status do pedido passando entre os dois sistemas.',
      kind: 'milestone',
      status: 'inProgress',
      plannedDate: '2026-10-20',
    },
    {
      id: 'r-golive',
      projectId: 'crm',
      title: 'Go-live da rede',
      description: 'Primeiras filiais operando o portal no dia a dia.',
      kind: 'release',
      status: 'planned',
      plannedDate: '2026-11-14',
    },
    {
      id: 'r-prototipo',
      projectId: 'app-vendedor',
      title: 'Protótipo com a equipe comercial',
      description: 'Fluxo de consulta e pedido validado com três vendedores.',
      kind: 'milestone',
      status: 'inProgress',
      plannedDate: '2026-11-03',
    },
    {
      id: 'r-piloto',
      projectId: 'app-vendedor',
      title: 'Piloto em uma regional',
      description: 'Uso real por uma semana, com ajuste do que travar o pedido.',
      kind: 'release',
      status: 'planned',
      plannedDate: '2026-12-08',
    },
  ],
  backlog: [
    {
      id: 'b-mapa',
      projectId: 'crm',
      reference: 'NOR-8',
      title: 'Mapa de pedidos do dia',
      description: 'Lista do que entrou, por filial, com status visível para o comercial.',
      priorityLabel: 'Alta',
      ownerName: 'Ana Ribeiro',
      status: 'done',
      labels: [{ name: 'Pedidos', tone: 'sky' }],
      inActiveSprint: true,
      sprintId: 's-out-1',
      startDate: '2026-10-05',
      endDate: '2026-10-07',
      commitment: 'confirmed',
    },
    {
      id: 'b-preco',
      projectId: 'crm',
      reference: 'NOR-12',
      title: 'Tabela de preço',
      description: 'Preço exibido no portal conforme a regra combinada na descoberta.',
      priorityLabel: 'Alta',
      ownerName: 'Marina',
      status: 'inProgress',
      labels: [{ name: 'Preço', tone: 'amber' }],
      inActiveSprint: true,
      sprintId: 's-out-1',
      startDate: '2026-10-08',
      endDate: '2026-10-11',
      commitment: 'confirmed',
    },
    {
      id: 'b-expedicao',
      projectId: 'crm',
      reference: 'NOR-15',
      title: 'Relatório de expedição',
      description: 'O que saiu do depósito e o que ainda aguarda separação.',
      priorityLabel: 'Média',
      ownerName: 'Rafael Lima',
      status: 'ready',
      labels: [{ name: 'Expedição', tone: 'orange' }],
      inActiveSprint: true,
      sprintId: 's-out-1',
      startDate: '2026-10-07',
      endDate: '2026-10-09',
      commitment: 'planned',
    },
    {
      id: 'b-filial',
      projectId: 'crm',
      reference: 'NOR-18',
      title: 'Filial no pedido',
      description: 'O pedido mostra a filial que vai receber e quem aprova na regional.',
      priorityLabel: 'Alta',
      ownerName: 'Ana Ribeiro',
      status: 'validation',
      labels: [{ name: 'Pedidos', tone: 'sky' }],
      inActiveSprint: true,
      sprintId: 's-out-1',
      startDate: '2026-10-09',
      endDate: '2026-10-11',
      commitment: 'planned',
    },
    {
      id: 'b-pagamento',
      projectId: 'crm',
      reference: 'NOR-21',
      title: 'Condição de pagamento',
      description: 'A condição combinada na descoberta aparece antes de confirmar o pedido.',
      priorityLabel: 'Média',
      ownerName: 'Rafael Lima',
      status: 'ready',
      labels: [{ name: 'Financeiro', tone: 'violet' }],
      inActiveSprint: false,
      sprintId: 's-out-3',
      startDate: '2026-10-20',
      endDate: '2026-10-24',
      commitment: 'planned',
    },
    {
      id: 'b-estoque',
      projectId: 'app-vendedor',
      reference: 'NOR-30',
      title: 'Consulta de estoque',
      description: 'Saldo por produto antes de fechar o pedido no celular.',
      priorityLabel: 'Alta',
      ownerName: 'Rafael Lima',
      status: 'inProgress',
      labels: [{ name: 'Estoque', tone: 'sky' }],
      inActiveSprint: true,
      sprintId: 's-app-1',
      startDate: '2026-10-06',
      endDate: '2026-10-11',
      commitment: 'confirmed',
    },
    {
      id: 'b-pedido-app',
      projectId: 'app-vendedor',
      reference: 'NOR-31',
      title: 'Pedido pelo celular',
      description: 'Carrinho simples, com o mesmo preço do portal.',
      priorityLabel: 'Média',
      ownerName: 'Marina',
      status: 'ready',
      labels: [{ name: 'Pedidos', tone: 'amber' }],
      inActiveSprint: true,
      sprintId: 's-app-1',
      startDate: '2026-10-07',
      endDate: '2026-10-11',
      commitment: 'planned',
    },
  ],
  comments: [
    {
      id: 'c1',
      projectId: 'crm',
      targetType: 'backlog',
      targetId: 'b-preco',
      authorName: 'Ana Ribeiro',
      fromClient: false,
      body: 'A tabela de preço vale por filial ou a rede inteira usa a mesma? Precisamos dessa confirmação para seguir a integração.',
      createdAt: '2026-10-05T14:30:00',
    },
    {
      id: 'c2',
      projectId: 'crm',
      targetType: 'roadmap',
      targetId: 'f-cronograma',
      authorName: 'Ana Ribeiro',
      fromClient: false,
      body: 'Compartilhei o cronograma de outubro. A previsão de homologação depende da confirmação das regras comerciais.',
      createdAt: '2026-10-04T15:30:00',
    },
    {
      id: 'c3',
      projectId: 'crm',
      targetType: 'roadmap',
      targetId: 'f-cronograma',
      authorName: 'Marina',
      fromClient: true,
      body: 'Recebi o cronograma. Vou confirmar as datas com a operação.',
      createdAt: '2026-10-05T09:18:00',
    },
    {
      id: 'c4',
      projectId: 'crm',
      targetType: 'roadmap',
      targetId: 'r-descoberta',
      authorName: 'Ana Ribeiro',
      fromClient: false,
      body: 'A etapa de descoberta foi concluída com o escopo combinado.',
      createdAt: '2026-09-18T16:10:00',
    },
  ],
  resolvedCommentTargets: ['r-descoberta'],
  files: [
    {
      id: 'f-cronograma',
      projectId: 'crm',
      name: 'Cronograma-outubro.pdf',
      sharedAt: '2026-10-04T11:00:00',
      sizeLabel: '240 KB',
    },
    {
      id: 'f-ata',
      projectId: 'crm',
      name: 'Combinados-da-descoberta.pdf',
      sharedAt: '2026-09-18T16:00:00',
      sizeLabel: '180 KB',
    },
  ],
  documentation: [
    {
      id: 'd-validar',
      title: 'Como validar um pedido',
      summary: 'O que conferir antes de liberar o pedido para separação.',
      publishedAt: '2026-10-03T09:00:00',
      body: [
        'Abra o pedido e confira filial, condição de pagamento e itens.',
        'Se o preço divergir da tabela combinada, devolva o pedido com um comentário no item Tabela de preço.',
        'Pedido conferido segue para expedição. O status passa a Em separação.',
      ],
    },
    {
      id: 'd-filial',
      title: 'Filiais e quem aprova',
      summary: 'Quem da Norte Atacado confirma pedido em cada regional.',
      publishedAt: '2026-09-20T09:00:00',
      body: [
        'Cada regional tem um aprovador titular e um substituto.',
        'Pedido acima do limite da regional sobe para a matriz.',
        'A lista de aprovadores fica com o comercial e pode ser atualizada por e-mail para a equipe do projeto.',
      ],
    },
  ],
  feedback: [
    {
      id: 'fb-descoberta',
      projectId: 'crm',
      title: 'Como foi a etapa de descoberta?',
      context: 'Marco Descoberta concluído em 18 de setembro, no projeto Implementação CRM.',
      prompt: 'De 1 a 5, como você avalia o alinhamento feito nessa etapa?',
      minScore: 1,
      maxScore: 5,
      submitted: false,
      score: null,
      comment: '',
    },
  ],
  activity: [
    {
      id: 'a-status',
      kind: 'status',
      title: 'Tabela de preço entrou em andamento',
      detail: 'Implementação CRM',
      happenedAt: '2026-10-05T10:00:00',
      href: '/portal/projects/crm?tab=backlog&item=b-preco',
      read: false,
    },
    {
      id: 'a-file',
      kind: 'file',
      title: 'Cronograma de outubro compartilhado',
      detail: 'Documento · Cronograma-outubro.pdf',
      happenedAt: '2026-10-04T11:00:00',
      href: '/portal/projects/crm?tab=sprints',
      read: false,
    },
    {
      id: 'a-doc',
      kind: 'page',
      title: 'Como validar um pedido',
      detail: 'Nova página de documentação',
      happenedAt: '2026-10-03T09:00:00',
      href: '/portal/documentation/d-validar',
      read: false,
    },
  ],
};
